<template>
	<div class="ReMediaPlan mb-5">
		<div class="d-flex">
			<h4 class="mr-2">Медиа-маркет</h4>
			<!-- <span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Статус: {{}}</span> -->
		</div>
		

		<p>Подключите и оплатите нужный Вам рекламный пакет. Можно подключить только один пакет.</p>

		<form class="ReMediaPlan-form row mt-3">
			<!-- <div class="row mt-3"></div> -->
				<div class="form-group col-md-4 col-sm-12">
					<label class="col-form-label"> Рекламный пакет</label>
					<el-select
						class="select-primary"
						size="large"
						placeholder="Рекламный пакет"
						v-model="selectedPlanId"
						@change="getSelectedPlanData"
						clearable
						filterable
					>
						<el-option
							v-for="(el_opt, el_index) in Marketingplans"
							class="select-primary"
							:value="el_opt.id"
							:label="el_opt.name"
							:key="el_index"
						>
						</el-option>
					</el-select>
					<template v-if="selectedPlanId">
						<p class="mt-2 mb-0">Длительность пакета: {{ this.objSelectedPlan.days }} дн </p>
						<p class="">Стоимость пакета: {{ this.objSelectedPlan.price }} ₽ </p>
						<ul class="row list-unstyled result-marker mb-3" v-if="this.objSelectedPlan.sites">
							<li v-for="(el_opt, el_index) in JSON.parse(this.objSelectedPlan.sites)" :key="el_index" class="col-xl-6 col-lg-12">
								{{ el_opt.site }} ({{ el_opt.term }})
							</li>
						</ul>
					</template>	
				</div>
				
				<div class="form-group col-md-3 col-sm-12">
					<label class="col-form-label">Срок действия</label>
					<el-select
						class="select-primary"
						size="large"
						placeholder="Срок действия"
						v-model="selectedPlanDuration"
						clearable
					>
						<el-option
							v-for="(el_opt, el_index) in plan_duration"
							class="select-primary"
							:value="el_opt.value"
							:label="el_opt.label"
							:key="el_index"
						>
						</el-option>
					</el-select>
				</div>

				<div class="form-group col-md-3 col-sm-12">
					<label class="col-form-label">С какого числа</label>
					<el-date-picker
						type="date"
						format="dd.MM.yyyy"
						value-format="yyyy-MM-dd"
						placeholder="С какого числа"
						:picker-options="pickerOptions2(startPlanToday)"	
						v-model="selectedPlanStartTime"		
						ref="dateUserInput"			
					>
					</el-date-picker>
					<base-checkbox v-model="startPlanToday" inline @input="switchPlanStart(startPlanToday)"> <span style="font-size: 14px;">Разместить объект сегодня </span></base-checkbox>
					<p class="mb-0"><i class="tim-icons text-danger icon-alert-circle-exc mr-2" style="font-size: 16px;"></i> Обратите внимание: оплата за текущий день спишется как за целый день</p>
				</div>
				<div class="btn-position col-md-2 col-sm-12 ">
					<base-button class="btn btn-success btn-simple my-0 w-100" @click="selectedPlanDataToPay(strCurTab)" >Оплатить {{ plan_price }} ₽</base-button>
				</div>
		</form>

		<div class="row px-3 mt-2">
			<ReSearchCardPlanHelp 
			v-for="(site,sindex) in planHelp"
			:site="site"
			:key="sindex"/>
		</div>

		
			<template v-if="TableData.length < 1 && actual == 0">
				<div class="ReMediaPlan-warning">
					<h3 class="warning-msg text-danger mb-1"><i class="tim-icons icon-alert-circle-exc"></i> Объект не рекламируется</h3>
					<p class="text-danger mb-3">К объекту не привязан ни один пакет (автоматический тоже не привязан)</p>
				</div>
			</template>
			<template v-if="duplicates != ''">
				<div class="ReMediaPlan-warning mb-3">
					<h3 class="warning-msg text-danger mb-1"><i class="tim-icons icon-alert-circle-exc"></i> Противоречие в пакетах</h3>
					<p class="text-danger mb-3">Есть противоречия в выбираемом пакете с уже действующими</p>
					<div class="text-align-start">
						<p>Вы уже подаетесь на площадку(ки): </p>
						<ul class="list-unstyled result-marker mb-3">
							<li  v-for="item in duplicates" :key="item.site">Текущее: {{ item.site }}"{{ item.term_old }}" &rarr; Выбрано: {{ item.site }} "{{ item.term_new }}"</li>
						</ul>
						<!-- <p>... далее Артем придумает текст</p> -->
					</div>
				</div>
			</template>
			
		

		<!-- <div class="auction">
			<div class="d-flex">
				<span class="badge badge-info mr-2 mb-0" style="font-size: 12px;">аукцион ЦИАН</span>
				<h4 class="mb-0 text-primary">Действует с {{  }}. Стоимость 210 ₽</h4>
			</div>
			<base-button class="btn btn-info btn-simple mt-3 mb-0">Настроить аукцион на ЦИАН</base-button>
		</div> -->

		<div class="ReMarketingSitesOnObj mt-3">
			<div class="d-flex align-items-center flex-wrap">
				<h4 class="mr-2 mb-2">Ваши площадки</h4>
				<p class="d-inline-flex align-items-center"> <i class="tim-icons text-danger icon-alert-circle-exc mr-1"></i> Информация по площадкам обновляется один раз в сутки (ночью)</p>	
				<!-- если есть хотя бы одна включенная. кнопка будет выключить все. если все выключены. делаем её на включение всех -->
				<base-button class="btn btn-success btn-simple my-0 ml-xl-auto" @click="setAllSites()" v-if="!allSitesAct">Снять объект со всех площадок</base-button>
				<base-button class="btn btn-success btn-simple my-0 ml-xl-auto" @click="setAllSites()" v-if="allSitesAct">В рекламу </base-button>
				<!-- <ReActionBtns :masActions="allSitesAction"/> -->
				<!-- <base-switch :key="act_index"
					v-model="action.action_model"
					type="primary"
					:on-text="action.label_on"
					:off-text="action.label_off"
					@change="DoApi(action)"
				></base-switch> -->
				<!-- <base-switch
					class="my-0 ml-auto" 
					v-model="allSitesAct"
					type="primary"
					on-text="Вкл"
					off-text="Выкл"
					@change="setAllSites()">
				</base-switch> -->
			</div>

			
			<tabs type="primary" 
				:activeTab="valueTab"
				v-model="strCurTab"
				@change="OnTabChange"
				ref="plansTabs"
				inline
				round	
				v-loading.fullscreen.lock="$GVO.fullscreenLoading"
				element-loading-text="Загрузка данных..."
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)"	
				class="card card-plain mt-3 mt-xl-0">
				<tab-pane :id="'currentPlans'" >
					<template v-slot:label>
						<span class="tab-label">
							<span>Текущие пакеты</span>
						</span>
					</template>
					<template>

						<el-table 
						:data="TableData" 
						style="width: 100%"
						@expand-change="rowClicked"
						
						:row-key="row => row.term_id"
						:expand-row-keys="expandRowKeys"
						ref="tableData" 
						:row-class-name="tableRowClassName"
						>	
						
							<!-- <el-table-column 
							width="100" 
							:cell-key="row => row.term_id"
							@cell-dblclick="expandRow">
								<template slot-scope="scope">
									<p>Показать ещё</p>
								</template>
							</el-table-column> -->
							<!-- <el-table-column 
							width="100" 
							>
								<template slot-scope="scope">
									<p>Показать ещё</p>
								</template>
							</el-table-column> -->

							<el-table-column 
								type="expand" 
								width="120"
								resizable
								sortable>
								<template v-slot="scope">
									<p>Пакет: {{ scope.row.plan_name }} <template v-if="scope.row.pause==1 && $GVO.my_profile.adm == 1"> (все сайты отключены пользователем)</template></p>
									<!-- <p class="text-danger">Ошибки: {{ scope.row.error }}</p> -->

									<!-- <div v-if="(scope.row.hasOwnProperty('statistic') && scope.row.statistic!='')">{{JSON.parse(scope.row.statistic)}}</div> -->

									<div class="row row-wrap mt-2 mb-2" v-if="(scope.row.hasOwnProperty('statistic') && scope.row.statistic!='')">
										<div class="col-12 col-md-4">
											<h6 class="text-primary">За все время:</h6>
											<p>Просмотров: {{ JSON.parse(scope.row.statistic).views}}</p>
											<p>Добавление в избранное: {{ JSON.parse(scope.row.statistic).favorites }}</p>
											<p>Просмотров контакта: {{ JSON.parse(scope.row.statistic).phones }}</p>
										</div>
										<div class="col-12 col-md-4">
											<h6 class="text-primary">За неделю:</h6>
											<p>Просмотров: {{ JSON.parse(scope.row.statistic).views_week }}</p>
											<p>Добавление в избранное: {{ JSON.parse(scope.row.statistic).favorites_week }}</p>
											<p>Просмотров контакта: {{ JSON.parse(scope.row.statistic).phones_week }}</p>
										</div>
										<div class="col-12 col-md-4">
											<h6 class="text-primary">За последние 30 дней:</h6>
											<p>Просмотров: {{ JSON.parse(scope.row.statistic).views_month }}</p>
											<p>Добавление в избранное: {{ JSON.parse(scope.row.statistic).favorites_month }}</p>
											<p>Просмотров контакта: {{ JSON.parse(scope.row.statistic).phones_month }}</p>
										</div>
									</div>

									<!-- div class="stat-conf my-2">
										<div class="stat-conf-item">
											<ReDateRange 
												v-model="objMediaDTRange"
											/>
										</div>
										<div class="ml-1 stat-conf-item">
											<button class="btn btn-icon btn-simple btn-primary" @click="">
												<i class="tim-icons icon-refresh-01"></i>
											</button>
										</div>
									</div -->

									<div v-if="!scope.row.hasOwnProperty('detail') || Object.keys('detail').length != 0">
										<ReMediaCharts :TheData="scope.row.detail"/>
									</div>
									<!-- <pre>{{scope.row.detail}}</pre> -->
								</template>
							</el-table-column>



							<el-table-column 
								min-width="120"
								label="Площадки"
								property="destination">
								<template v-slot="scope">
									<div class="siteblock">
										<p class="d-inline-flex align-items-center text-danger mr-2" v-if="scope.row.hasOwnProperty('error') && scope.row.error!=''"> 
											<i class="tim-icons text-danger icon-alert-circle-exc mr-1"></i> Есть ошибки</p>	

										<p v-if="!scope.row.hasOwnProperty('link') || scope.row.link==''" class="mr-2" 
										:class="[{'text-danger': (scope.row.hasOwnProperty('error') && scope.row.error!='')}]">{{scope.row.site_name}} </p>
										<template v-if="scope.row.link && scope.row.link!=''">
											<a :href="scope.row.link" target="_blank" class="mr-2" 
											:class="[{'text-danger': (scope.row.hasOwnProperty('error') && scope.row.error!='')}]">{{scope.row.site_name}} </a>
										</template>
										<p > ({{scope.row.term_name}})</p>
									</div>
										
										<template v-if="scope.row.status && scope.row.status=='WAITING'">
											<span>(Поиск ссылки)</span>
										</template>
										<template v-if="scope.row.status && scope.row.status=='IGNORED'">
											<span>(ссылка не предусмотрена площадкой)</span>
										</template>
									
								</template>
							</el-table-column>

							<!-- <el-table-column 
								min-width="200"
								label="Вид продвижения"
								property="term_name">
							</el-table-column> -->

							<el-table-column
							label="Старт"
							min-width="120"
							prop="dfrom">
								<template v-slot="scope">
									<p>
									{{ $GVO.convertDateFromMysql(scope.row.dfrom) }}
									</p>
								</template>
							</el-table-column>
							<el-table-column
							label="Снятие (в 00:01)"
							min-width="120"
							prop="dto"
							:sort-method="sortInt_id">
								<template v-slot="scope">
									<p>
									{{ $GVO.convertDateFromMysql(scope.row.dto) }}
									</p>
								</template>
							</el-table-column>

							<!-- <el-table-column
							label="Дата по"
							min-width="120"
							prop="dto">
								<template slot-scope="scope">
									{{ $GVO.convertDateFromMysql(scope.row.dto) }}
								</template>
							</el-table-column> -->
							<el-table-column 
								min-width="200"
								label="Ошибки"
								property="error">
								
								<template v-slot="scope">
									<div class="text-danger">
										{{ scope.row.error }}
									</div>
								</template>
							</el-table-column>
							
							<!-- <el-table-column 
								min-width="120"
								label="Просмотры"
								property="view">
							</el-table-column> -->
							<el-table-column
								label="Автопродление"
								property="autoprolongate"
								>
								<template v-slot="scope">
									<template v-if="hasAutoProlongate && scope.row.has_autoprolongate==1">
										<ReActionBtns v-if="planButtons[scope.row.plan_id]" :masActions="planButtons[scope.row.plan_id]" @change.stop="expandRow()"/>
									</template>
									<template v-else-if="scope.row.autoprolongate==1">
										Да
									</template>
								</template>
							</el-table-column>
							<el-table-column 
								min-width="110"
								label="Активность выгрузки"
								property="act"
								>
								<template v-slot="scope">
									<ReActionBtns v-if="siteButtons[scope.row.site_id]" :masActions="siteButtons[scope.row.site_id]" @change.stop="expandRow()"/>
								</template>
							</el-table-column>
							<el-table-column 
								min-width="55"
								label="Смена ID"
								property="act"
								v-if="$GVO.my_profile.adm == 1"
								>
								<template v-slot="scope">
									<button v-if="$GVO.my_profile.adm == 1 && scope.row.local==2" class="ml-1 mb-0 btn btn-icon btn-simple btn-primary" @click="$GVO.showYesNo(function(){refreshId({'object_id': objId, site_id: scope.row.site_id, term_id: scope.row.term_id, act: scope.row.act, incObjectId:1});},'Обновить ID','Это действие снимет объект с рекламы на этой площадке и выставит ещё раз. Продолжаем?');">
										<i class="tim-icons icon-refresh-01"></i>
									</button>
									{{ (scope.row.change_id>0)?`-${scope.row.change_id}`:'' }}
								</template>
							</el-table-column>							
						</el-table>
						<!-- <el-table ref="multipleTable" :data="TableData" style="width: 100%">	
							<el-table-column 
								min-width="200"
								label="Площадки"
								property="destination">
								<template slot-scope="scope">
									<p>{{scope.row.site_name}}</p>
									<template v-if="scope.row.link && scope.row.link!=''">
										<a :href="scope.row.link" target="_blank">Посмотреть на площадке</a>
									</template>
									<template v-if="scope.row.status && scope.row.status=='WAITING'">
										(Поиск ссылки)
									</template>
									<template v-if="scope.row.status && scope.row.status=='IGNORED'">
										(Не предусмотрено площадкой)
									</template>
								</template>
							</el-table-column>
							<el-table-column 
								min-width="200"
								label="Вид продвижения"
								property="term_name">
							</el-table-column>

							<el-table-column
							label="Пакет"
							min-width="210"
							prop="plan_name">
							</el-table-column>

							<el-table-column
							label="Дата с"
							min-width="120"
							prop="dfrom">
								<template slot-scope="scope">
									{{ $GVO.convertDateFromMysql(scope.row.dfrom) }}
								</template>
							</el-table-column>

							<el-table-column
							label="Дата по"
							min-width="120"
							prop="dto">
								<template slot-scope="scope">
									{{ $GVO.convertDateFromMysql(scope.row.dto) }}
								</template>
							</el-table-column>
							<el-table-column 
								min-width="200"
								label="Ошибки"
								property="error">
								
								<template slot-scope="scope">
									<div class="text-danger">
										{{ scope.row.error }}
									</div>
								</template>
							</el-table-column>
							
							<el-table-column 
								min-width="120"
								label="Просмотры"
								property="view">
							</el-table-column>
							<el-table-column 
								min-width="140"
								label="Активность выгрузки"
								property="act">
								<template slot-scope="scope">
									<ReActionBtns :masActions="masActions[scope.$index]"/>
								</template>
							</el-table-column>
						</el-table> -->
						
					</template>
				</tab-pane>

				<tab-pane :id="'futurePlans'" class="leadhistory">
					<template v-slot:label>
						<span class="tab-label">
							<span>Запланированные пакеты</span>
						</span>
					</template>
					<template >
						<el-table ref="multipleTable" :data="TableData" style="width: 100%">	
							<!-- <el-table-column 
								type="expand" 
								width="120"
								resizable
								sortable>
								<template slot-scope="scope">
									<p>Пакет: {{ scope.row.plan_name }}</p>
									<p v-if="scope.row.view">Просмотры: {{ scope.row.view }}</p>
									<p v-if="scope.row.error" class="text-danger">Ошибки: {{ scope.row.error }}</p>
							
								</template>
							</el-table-column> -->

							<el-table-column 
								min-width="120"
								label="Площадки"
								property="plan_name"
								>
								<template v-slot="scope">
									<p>Пакет: {{ scope.row.plan_name }}</p>
									<template v-if="scope.row.pause==1 && $GVO.my_profile.adm == 1"> (все сайты отключены пользователем)</template>
								</template>
							</el-table-column>

							<el-table-column 
								min-width="200"
								label="Площадки"
								property="destination">
								<template v-slot="scope">
									<div class="siteblock">
										<!-- <p v-if="!scope.row.hasOwnProperty('link')" class="mr-2">{{scope.row.site_name}} </p>
										<template v-if="scope.row.link && scope.row.link!=''">
											<a :href="scope.row.link" target="_blank" class="mr-2">{{scope.row.site_name}} </a>
										</template> -->
										<p class="mr-2">{{scope.row.site_name}}</p>
										<p> ({{scope.row.term_name}})</p>
									</div>

									<!-- <template v-if="scope.row.link && scope.row.link!=''">
										<a :href="scope.row.link" target="_blank">Посмотреть на площадке</a>
									</template>
									<template v-if="scope.row.status && scope.row.status=='WAITING'">
										(Поиск ссылки)
									</template>
									<template v-if="scope.row.status && scope.row.status=='IGNORED'">
										(Не предусмотрено площадкой)
									</template> -->
								</template>
							</el-table-column>
							

							<el-table-column
							label="Старт"
							width="120"
							prop="dfrom">
								<template v-slot="scope">
									<p class="text-right">
									{{ $GVO.convertDateFromMysql(scope.row.dfrom) }}
									</p>
								</template>
							</el-table-column>
							<el-table-column
							label="Снятие (в 00:01)"
							width="150"
							prop="dto">
								<template v-slot="scope">
									<p class="text-right">
									{{ $GVO.convertDateFromMysql(scope.row.dto) }}
									</p>
								</template>
							</el-table-column>

							<el-table-column
								label="Автопродление"
								property="autoprolongate"
								>
								<template v-slot="scope">
									<template v-if="hasAutoProlongate && scope.row.has_autoprolongate==1">
										<ReActionBtns v-if="planButtons[scope.row.plan_id]" :masActions="planButtons[scope.row.plan_id]" @change.stop="expandRow()"/>
									</template>
									<template v-else-if="scope.row.autoprolongate==1">
										Да
									</template>
								</template>
							</el-table-column>

							<el-table-column 
								width="140"
								label="Активность выгрузки"
								property="act"
								>
								<template v-slot="scope">
									<ReActionBtns v-if="siteButtons[scope.row.site_id]" :masActions="siteButtons[scope.row.site_id]" @change.stop="expandRow()"/>
								</template>
							</el-table-column>							
							<el-table-column
							label="Действие"
							width="110"
							prop="act">
								<template v-slot="scope">
									<button class="ml-3 btn btn-icon btn-simple btn-danger" @click="DeletePlan(scope.row)">
										<i class="tim-icons icon-trash-simple"></i>
									</button>	
								</template>
							</el-table-column>
							
						</el-table>
					</template>	
				</tab-pane>

				<tab-pane :id="'marketingHistory'" class="leadhistory">
					<template v-slot:label>
						<span class="tab-label">
							<span>История подачи в рекламу</span>
						</span>
					</template>
					<template >
						<ReMarketingHistory
							:objId="objId"
						/>
					</template>
				</tab-pane>
			</tabs>

			<Pagination class="mt-3" :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
				:type="'info'" 
				:total="parseInt(masObjects_total)" 
				:perPage="parseInt(10)"
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination>

		</div>

	</div>
</template>

<script>
	// import { reactive } from 'vue';
	import { DatePicker, Select, Option, Table, TableColumn, Tooltip, Button, Checkbox } from 'element-ui';
	import Plural from 'src/mixins/Plural.js';
	// import { BaseRadio } from 'src/components/index';
	import Pagination from 'src/our_components/RePagination';
	import ReActionBtns from 'src/our_components/ReActionBtns.vue';
	import swal from 'sweetalert2';
	// import { BaseSwitch } from 'src/components/index';
	import { TabPane, Tabs } from 'src/components';
	import ReMediaCharts from 'src/our_modules/MarketingModule/ReMediaCharts.vue';
	import ReMarketingHistory from 'src/our_modules/MarketingModule/ReMarketingHistory.vue';
	// import ReDateRange from "src/our_components/ReDateRange.vue";

	import ReSearchCardPlanHelp from "src/our_modules/MarketingModule/ReSearchCardPlanHelp.vue";

/*
я тут до конца осознал про v-model и props value внутри компонента:
радовался тому что в value можно писать и всё работает - нихрена. 
1) Если value сложный тип (например массив или объект) - тогда можно элементы массива/объекта и ничего за это не будет, т.к. ЖС говно
2) Если тип простой string или number - то хер чё поменяешь в value, только this.$emit('input', 'ЗНАЧЕНИЕ');
3) Если напрямую переписывать сложные тип, например value = {key:'value'} - то хер, будет ошибка
а ещё во всех слуаях он выдаст ошибку, но значение в value запишет
*/
/* Сломалась реактивность на объекте или массиве: 
	Этот чудесный кослыль родился потому что VUE не может нормально следить за массивами и теряется реактивность
	https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats

Для объекта:
	this.$set(this.objChosenTP,this.ApiData[i].siteId, {'choise':'','cost':0, 'phone':{"contact_id":"","contact_type":"1","contact_value":"","contact_view":"","contact_group":"phone"}});
Для Массива:
	Vue.set(this.masCheckListParams,obj_index, [{val_id:obj_index, elements: masElements}]);
*/
	export default {
		name: 'ReMediaPlan',
		mixins: [Plural],
		components: {
			[Select.name]: Select,
			[Option.name]: Option,
			[DatePicker.name]: DatePicker,
			[Table.name]: Table,
			[TableColumn.name]: TableColumn,
			[Tooltip.name]: Tooltip,
			[Button.name]: Button,
			[Checkbox.name]: Checkbox,
			Pagination,
			// BaseRadio,
			ReActionBtns,
			// BaseSwitch,
			TabPane, 
			Tabs,
			ReMediaCharts,
			ReMarketingHistory,
			// ReDateRange,
			ReSearchCardPlanHelp,
		},
		props: {
			counter: String,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			objId: [String, Number],
			object_type: String,
			deal_type: String,
			value: String,
			hasAutoProlongate: Boolean,
			valueTab: {
				type: String,
				default: 'currentPlans', // flats||flatmap
			}, 
			regionId: [String, Number],
			actual: [String, Number],
			
		},
		data () {
			return {
				ver: 1,
				bufferValue: '',
				fullscreenLoading: false,
				arrZipalCats:[],
				dealTypeToMedia:'',
				objectTypeToMedia: '',
				Marketingplans: [],
				plan_duration: [],
				objSelectedPlan:{price:0,},
				selectedPlanId:'',
				selectedPlanDuration:'',
				selectedPlanStartTime:'',
				selectedPlanData: [],
				planHelp: [],
				duplicates: [],
				TableData: [],
				objGetParams:{},
				masObjects_total: 0,
				masActions:[],
				siteButtons:{},
				planButtons:{},
				htmlarray: [],
				startPlanToday: false,
				// pickerOptions: {
				// 	disabledDate(time) {
				// 		return time.getTime() < Date.now();
				// 	},
				// 	firstDayOfWeek:1,
				// },
				today:'',
				iTechBalance: null,
				allSitesAct: true,
				changeAll: true,
				changeAllSites: [],
				strCurTab:'currentPlans',
				hehe: 'hehe',
				expandRowKeys: [],
				// allSitesAction:[],
				objMediaDTRange:{startDt:this.addMonths(new Date(),-1),endDt:new Date()},
			}
		},
		watch:{
			value(val){
				this.bufferValue = this.$GVO.unlinkObject(val);
			},
			bufferValue(val){
				this.bufferValue = val;
				this.$emit("input", this.bufferValue);
			},
			selectedPlanId(planId){
				this.showMediaExample(planId);
			}
		},
		computed: {
			plan_price(){
				return (this.objSelectedPlan.price) * (this.selectedPlanDuration||0);
			},
			
		},
		methods: {
			addMonths(date, months) {
				date.setMonth(date.getMonth() + months);
				return date;
			},
			resetForm(){
				this.startPlanToday=false;
				this.selectedPlanStartTime='';
				this.selectedPlanDuration='';
				this.selectedPlanId = '';
				this.getSelectedPlanData(-1);
			},
			
			pickerOptions2(data){
				// console.log('data', data);
				let yesterday = this.yesterdayDate();
				let result = {
					disabledDate(time) {
						if(data == true){
							return time.getTime() < yesterday;
						}else {
							return time.getTime() < Date.now();
						}
					},
					firstDayOfWeek:1,
				};
				return result;
			},
			switchPlanStart(data){
				if(data == true){
					this.selectedPlanStartTime = this.today;
					this.pickerOptions2(this.today);
				}
				else {
					this.selectedPlanStartTime = '';
				}
				// this.selectedPlanStartTime = '';
				this.pickerOptions2(data);
			},
			sortInt_id(a,b){
				return parseInt(a.id) - parseInt(b.id);
			},
			todayDate(){
				const today = new Date();
				const year = today.getFullYear();
				const month = String(today.getMonth() + 1).padStart(2, '0');
				const day = String(today.getDate()).padStart(2, '0');
				this.today = `${year}-${month}-${day}`;
			},
			yesterdayDate(){
				let date = new Date();
				let yesterday = date.setDate(date.getDate() - 1);
				return yesterday;
			},
			showMediaExample(planId){
				this.planHelp = [];
				this.$GVO.ApiCall('marketing_plan.GET_HELP',{
					flt:{
						'id':planId,
					}
				}) //'deal_type': this., 'object_type': this.
				.then((objApi) => {
					if(objApi.data)
						this.planHelp = objApi.data.map((row)=>((row.photo=row.photo>''?JSON.parse(row.photo):null),row));
				}).catch(errorObjApi => console.error(errorObjApi));
			},
			getMarketingplans(){
				// console.log('getMarketingplans is worked');
				// console.log(this.objectTypeToMedia);
				
				this.$GVO.ApiCall('marketing_plan.GET',{
					flt:{
						'act':1,
						'deal_type': this.dealTypeToMedia,
						'object_type': this.objectTypeToMedia,
						'regionId': this.regionId,
						'no_paging': 1,
						// 'autoplan': false,
						objectId: this.objId,
					}
				}) //'deal_type': this., 'object_type': this.
				.then((objApi) => {
					if(objApi.success === true){
						if(objApi.data.length > 0){
							this.Marketingplans = objApi.data; 
						}
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			},
			getSelectedPlanData(selectedPlanId){
				this.plan_duration=[];
				this.selectedPlanData=[];
				this.duplicates=[];
				for(let i=0; i < this.Marketingplans.length; i++){
					if(selectedPlanId == this.Marketingplans[i].id ){
						this.objSelectedPlan = this.Marketingplans[i];
						this.getPlanDuration(this.Marketingplans[i].days, this.Marketingplans[i].len_limit);
						// console.log(this.Marketingplans[i].name);
					}
				}
			},
			getPlanDuration(days, len){
				for(let i=1; i <= len; i++) {
					// console.log(i);
					this.plan_duration.push({'value':i,'label': (days * i) + this.Plural((days * i),' день',' дня',' дней')}); 
				}
			}, 
			getTechBalance(){
				this.$GVO.ApiCall('billing.getTechBalance',{flt:{staff_code:this.$GVO.my_profile.code}})
				.then((objApi) => {
					if(objApi.success === true){
						this.iTechBalance = parseFloat(objApi.data.tech_balance);
						// console.log('this.iTechBalance0',this.iTechBalance);
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			},
			checkPlanResult(result){
				// console.log(this);
				if(result && result.data && result.data.sites_disable)
					this.checkSitesDisable(result.data.sites_disable);
				// this.resetForm();
			},
			checkSitesDisable(sites){
				let time = this.selectedPlanStartTime;
				if(sites && sites.length>0){
					swal({
						title: 'Отключенные площадки',
						type: 'info',

						confirmButtonClass: 'btn btn-danger btn-fill',
						confirmButtonText: 'Хорошо',
						buttonsStyling: false,

						html: 	'В оплаченном пакете есть площадки, куда объект не выгружается в настоящий момент.<br/>Проверьте актуальность запрета и при необходимости включите нужные площадки',

					}).then(result=>{
						this.OnTabChange(time==new Date().toISOString().split('T')[0]?'currentPlans':'futurePlans');
						setTimeout(()=>{
						this.$refs.plansTabs.$el.scrollIntoView({
							behavior: 'smooth', // плавный скролл
							block: 'start',     // скролл к верху элемента
							inline: 'nearest'   // ближайший по горизонтали
						});

						},200)
					});
				}
			},
			selectedPlanDataToPay(strCurTab){
				if(this.selectedPlanDuration && this.selectedPlanStartTime && this.selectedPlanId) {
					// console.log('this.strCurTab',strCurTab);
					//this.selectedPlanData.push();
					this.htmlarray = [];
					this.getTechBalance();
					// console.log('this.plan_price',this.plan_price);
					// console.log('this.iTechBalance1',this.iTechBalance);

					

					this.$GVO.ApiCall('marketing_plan.INS_to_obj', 
					{flt:{'object_id':this.objId}, iData:{selectedPlanDuration:this.selectedPlanDuration, selectedPlanStartTime:this.selectedPlanStartTime, selectedPlanId:this.selectedPlanId}}
					).then(res=>{
						this.checkPlanResult(res);
						this.getTableData(strCurTab);
						// console.log(res.msg);
						// console.log('this.iTechBalance2',this.iTechBalance);

						if (this.iTechBalance < this.plan_price){
								swal({
									title: 'Ошибка счета',
									type: 'error',

									confirmButtonClass: 'btn btn-danger btn-fill',
									confirmButtonText: 'Отменить',
									buttonsStyling: false,

									html: 	'<div class="notEnoughMoney">'+
											'<p style="color: #1d253b!important;">Недостаточно средств на счете, пополните балланс</p>'+
											'<a href="/data/billing/my_money?range_type=5">Пополнить баланс</a>'+
											'</div>',

								});
							} else {
							
								if( res &&
									res.data
								){
									if(
										res.data.duplicate
									){
										this.duplicates = res.data.duplicate;
										// alert(res.data.duplicate.join('\n'));
										
										for(let i = 0; i < res.data.duplicate.length; i++){
											this.htmlarray.push(`<p>Текущее: ${res.data.duplicate[i].site} "${res.data.duplicate[i].term_old}" &rarr; Выбрано: ${res.data.duplicate[i].site} "${res.data.duplicate[i].term_new}"</p>`);
										}
										let htmlForSwal = this.htmlarray.join('\n');
										swal({
											title: 'Противоречие в пакетах',
											text: 'Вы точно хотите продолжать покупку?',
											type: 'warning',
											showCancelButton: true,
											confirmButtonText: 'Да, оплатить пакет',
											cancelButtonText: 'Нет',
											showCloseButton: true,
											showLoaderOnConfirm: true,
											buttonsStyling: false,
											focusConfirm: false,
											confirmButtonClass: 'btn btn-success btn-fill',
											cancelButtonClass: 'btn btn-danger btn-fill',

											html: `<div class="error-content">
													<p>Есть противоречия в выбираемом пакете с уже действующими. Вы уже подаетесь на площадку(ки):</p>
													<div>${htmlForSwal}</div>
												</div>`,
										}).then((result) => {
											// console.log('result',result);
											if(result.value) {
												this.duplicates = [];
												
												this.$GVO.ApiCall('marketing_plan.INS_to_obj', 
												{flt:{'object_id':this.objId, force:1}, iData:{selectedPlanDuration:this.selectedPlanDuration, selectedPlanStartTime:this.selectedPlanStartTime, selectedPlanId:this.selectedPlanId, }}
												).then((objApi) => {
													this.checkPlanResult(objApi);

													// console.log('objApi',objApi);
													if(objApi.success === true){
														// if(objApi.data.length > 0){
															// console.log('result.value after "force":1' + result.value);
														// }
														this.getTableData(strCurTab);
														this.selectedPlanDuration = '';
														this.selectedPlanStartTime = '';
														this.selectedPlanId = '';
														this.checkPlanResult(objApi);
														this.resetForm();
														// this.htmlarray = [];
													} 
													// else {
													// 	this.selectedPlanDuration = '';
													// 	this.selectedPlanStartTime = '';
													// 	this.selectedPlanId = '';
														
													// }
												}).catch(errorObjApi => console.error(errorObjApi));
												
											}
										});
									}else{
										this.resetForm();
									}
									
								} else if (res.msg){
									swal({
										title: 'Ошибка счета',
										buttonsStyling: false,
										confirmButtonClass: 'btn btn-danger btn-fill',

										html: `<div class="error-content">
												<!--p>У сотрудника нет счета или счет не найден</!--p-->
												<p>${res.msg}</p>
											</div>`,
									});

								} else{
									
								}

							} // заканчивается проверка на iTechBalance
						
						
					}).catch(e=>console.error(e));

				
					
				}
			},
			pClick(e){
				this.objGetParams['p'] = parseInt(e);
			},
			getTableData(strCurTab){
				this.TableData = [];
				let futureParam=';'
				if( strCurTab == 'currentPlans'){
					futureParam = 0;
				}else if (strCurTab == 'futurePlans'){
					futureParam = 2;
				} else {futureParam = 1;}
				this.$GVO.ApiCall('marketing_plan.GET_object_markets',{flt:{
					'object_id':this.objId,
					future: futureParam,
					// future:0, // Текущая реклама
					// future:1, // последняя поднанная реклама
					// future:2, // Реклама которая ещё не вышла

				}})
				.then((objApi) => {
					if(objApi.success === true){
						if(objApi.data.length > 0){
							this.TableData = objApi.data;
							// this.$refs.multipleTable.doLayout();

							this.masActions = [];
							this.changeAllSites = [];
							// let actchange='';
							// if(this.actual == '0'){
							// 	actchange = false;
							// } else {actchange = '1'?true:false;} //this.actual считается на бэкэ. если сам объект акт=1, статус модерации 1 или 2, и сайтов > 0, то будет 1 (автивно)

							for (let i = 0; i < this.TableData.length; i++) {
								let row = this.TableData[i];
								let me=this;
								this.$set(this.planButtons, row.plan_id, [{
										actionType: 'switcher',
										label_on: 'Вкл',
										label_off: 'Выкл',
										// action_model: row.act==actchange,	
										action_model: row.autoprolongate=='1'?true:false,	
										changeState(apiData, state){
											// console.log(state);
											// me.siteButtons[row.site_id].action_model=state;
											apiData.apiParam.flt.act = state?1:0
										},
										onSuccess(data){
											// console.log('set',data);
											let sb = me.planButtons[row.plan_id];
											sb[0].action_model = !!data.data.autoprolongate;
											me.$set(me.planButtons, row.plan_id, sb);
											// me.siteButtons[row.site_id][0].action_model=state;
											// console.log(this, data, me,row);
										},
										onClickApi: {
											apiMethod: 'SET_object_plan_autoprolongate',
											apiParam:{
												obj:'marketing_export',
												flt:{
													'object_id':this.objId,
													'plan_id': row.plan_id,
													'act': row.autoprolongate=='1'?'0':'1'
												}
											}
										}, 
									},]);
								this.$set(this.siteButtons, row.site_id, [{
										actionType: 'switcher',
										label_on: 'Вкл',
										label_off: 'Выкл',
										// action_model: row.act==actchange,	
										action_model: row.act=='1'?true:false,	
										changeState(apiData, state){
											// console.log(state);
											// me.siteButtons[row.site_id].action_model=state;
											apiData.apiParam.flt.act = state?1:0
										},
										onSuccess(data){
											// console.log('set');
											let sb = me.siteButtons[row.site_id];
											sb[0].action_model = !!data.data.act;
											me.$set(me.siteButtons, row.site_id, sb);
											// me.siteButtons[row.site_id][0].action_model=state;
											// console.log(this, data, me,row);
										},
										onClickApi: {
											apiMethod: 'SET_object_site',
											apiParam:{
												obj:'marketing_plan',
												flt:{
													'object_id':this.objId,
													'term_id': row.term_id,
													'site_id': row.site_id,
													'act': row.act=='1'?'0':'1'
												}
											}
										}, 
									},]);
								this.changeAllSites.push({
									'site_id': row.site_id,
									// 'term_id': row.term_id,
								});

							}
							//если есть хотя бы одна включенная. кнопка будет выключить все. если все выключены. делаем её на включение всех
							for (let j = 0; j < this.TableData.length; j++) {      
								if (this.TableData[j].act == 1) {
									// console.log('act == 1',this.TableData[j].term_id);
									this.allSitesAct = false;
									break;
								}else {
									this.allSitesAct = true; 
									// console.log('act == 0',this.TableData[j].term_id);
								}
							}
							// this.selectedPlanDuration = '';
							// this.selectedPlanStartTime = '';
							// this.selectedPlanId = '';
							
						}
					} 
				}).catch(errorObjApi => console.error(errorObjApi));
			},

			refreshId(flt){
				this.$GVO.ApiCall('marketing_plan.SET_object_site',{flt})
				.then((objApi) => {
					if(objApi.success === true){
						swal({
							title: 'Успех',
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-danger btn-fill',

							text: 'Код объект в выгрузке обновлен',
						});
						this.getTableData();
					}else{alert(objApi.msg);}
				}).catch(errorObjApi => console.error(errorObjApi));
			},
			setAllSites(){

				let sawlText = '';
				let act = '';
				act = this.allSitesAct == true ? '1' : '0';
				sawlText = this.allSitesAct == true ? 'Вы точно хотите выгрузить объект на все площади?' : 'Вы точно хотите снять объект со всех площадок?';
				// console.log('act', act);
						
				swal({
					title: 'Подача в рекламу',
					text: sawlText,
					type: 'warning',
					showCancelButton: true,
					confirmButtonText: 'Да',
					cancelButtonText: 'Нет',
					showCloseButton: true,
					showLoaderOnConfirm: true,
					buttonsStyling: false,
					focusConfirm: false,
					confirmButtonClass: 'btn btn-success btn-fill',
					cancelButtonClass: 'btn btn-danger btn-fill',
				}).then((result) => {
					if(result.value) {
						// swal('Начато', 'Вы успешно запустили задачу', 'success', 'btn btn-success btn-fill');
						// this.$GVO.ApiCall('marketing_plan.SET_object_site',{flt:{'object_id':this.objId, 'changeAll': this.changeAll, 'act': this.allSitesAct=='1'?'0':'1'}})

						this.$GVO.ApiCall('marketing_plan.SET_object_site',{flt:{'object_id':this.objId, 'allSites': this.changeAllSites, 'act': act}})
						.then((objApi) => {
							if(objApi.success === true){
								//console.log(objApi);
								// if(this.changeAll==true){
								// 	this.changeAll = true;
								// 	console.log('снято');
								// }else{this.changeAll = false; console.log('запущено обратно');}
								this.getTableData();
								// this.getTableData(strCurTab);
								
							}else{alert(objApi.msg);}
						}).catch(errorObjApi => console.error(errorObjApi));
					} 
				});
			},
			OnTabChange(strTabId){
				if(this.strCurTab == strTabId) return true;
				this.strCurTab = strTabId;
				this.$emit('input', strTabId);
				this.$emit('change', strTabId);
				// console.log('OnTabChange', strTabId);
				this.getTableData(strTabId);
				// if(strTabId == 'lead'){location.reload();}
			},
			DeletePlan(row){
				// console.log(row);
				if(row.plan_id != null){
					let htmlForSwal = '"'+row.plan_name+'"';
					swal({
						title: 'Удалить пакет?',
						text: 'Вы точно хотите отменить применение пакета?',
						type: 'warning',
						showCancelButton: true,
						confirmButtonText: 'Да, отменить пакет',
						cancelButtonText: 'Нет',
						showCloseButton: true,
						showLoaderOnConfirm: true,
						buttonsStyling: false,
						focusConfirm: false,
						confirmButtonClass: 'btn btn-success btn-fill',
						cancelButtonClass: 'btn btn-danger btn-fill',

						html: `<div class="error-content">
								<p>Вы хотите удалить пакет: ${htmlForSwal}</p>
								<div>Денежные средства за пакет вернутся на счет плательщика в Reactor</div>
							</div>`,
					}).then(result=>{
						if(result.value) {
							this.$GVO.ApiCall('marketing_plan.del_to_obj',{ flt:{
								'object_id':this.objId, 
								'id': row.plan_id, 
								}}) 
								.then((objApi) => {
									if(objApi.success === true){
										this.getTableData('futurePlans');
									}else{
										// alert('Не срослось');
										swal({
											title: 'Ошибка',
											buttonsStyling: false,
											confirmButtonClass: 'btn btn-danger btn-fill',

											html: `<div class="error-content">
													<p>Что-то пошло не так</p>
													<p>${objApi.msg}</p>
												</div>`,
										});
									}
								}).catch(errorObjApi => {console.error(errorObjApi);});						
						}
					})
				/*
					
				*/

				}

			},
			tableRowClassName({row, rowIndex}) {
				// if(row.RecID == '') {
					// тут меняем классы. скрываем иконку, если нет записи звонка
				// 	// console.log(objApi);
				// 	return 'row-expand-cover';
				// } else {
				// 	return 'row-expand-hover';
				// }
				return 'row-expand-hover';
			},
			rowClicked(row, expandedRows) {
				// console.log(row);
				const id = row.term_id; //row.$index; 
				const lastId = this.expandRowKeys[0];
				// disable mutiple row expanded 
				this.expandRowKeys = id === lastId ? [] : [id];
				
				if(expandedRows !='') {
					// this.getCall(row.RecID); //тут будет функция получающая данные для графиков
					// console.log(row.RecID);
				} //else {this.strAudioLink ='';}
				// this.expandRow(row, column, cell, event);
			},
			expandRow (row, event, column) {
				//use @click.stop="yourButtonFn" and it won't propagate to the row.
				this.$refs.tableData.toggleRowExpansion(row);
			},
			cellClicked(row, column, cell, event){
				// console.log('clicked');
			}
		},
		mounted() {

			this.$GVO.ApiCall('cat.GET_ZIPAL_CAT',{params:['ObjectType','DealType']})
			.then((objApi) => {
				
				if(objApi.success === true){
					for (const key in objApi.data) {
						if (Object.hasOwnProperty.call(objApi.data, key)) {
							this.$GVO.cats[key] = [];
							for (let i = 0; i < objApi.data[key].length; i++) {
								this.$GVO.cats[key].push({'id':objApi.data[key][i].value,'name':objApi.data[key][i].label});
							}
						}
					}
					this.arrZipalCats = objApi.data;
					
					for(let deal = 0; deal < this.arrZipalCats.DealType.length; deal++){
						if(this.deal_type == this.arrZipalCats.DealType[deal].label){
							this.dealTypeToMedia = this.arrZipalCats.DealType[deal].value;
						}
					}
					for(let obj = 0; obj < this.arrZipalCats.ObjectType.length; obj++){
						if(this.object_type == this.arrZipalCats.ObjectType[obj].label){
							this.objectTypeToMedia = this.arrZipalCats.ObjectType[obj].value; //console.log(this.objectTypeToMedia);
						}
					}
					this.getMarketingplans();
					
				}
			}).catch(errorObjApi => {console.error(errorObjApi); this.arrObjTypeOpts = [];});
			
			this.todayDate();
			this.getTableData('currentPlans');
		}
	}
</script>
<style scoped>

.ReMediaPlan {border: 1px solid #01b0e0; padding: 20px; border-radius: 6px;}
.ReMediaPlan-warning {border: 1px dashed #F84E54; padding: 20px 5px 0px 15px; border-radius: 6px; }
.ReMediaPlan-warning, .warning-msg {display: flex; flex-direction: column; align-items: center;}
.ReMediaPlan .badge {line-height: inherit;}
.ReMediaPlan-form {display: flex; flex-direction: row; align-items: flex-start;}
.auction, .ReMediaPlan-plan {    
	margin: 15px 0px;
    border-radius: 6px;
    padding: 10px;
}
.auction {border: 1px dashed #BA54F5;}
.ReMediaPlan-plan {border: 1px dashed #01B0E0; }
.ReMediaPlan-form .btn-position {margin-top: 32px;}

.ReMarketingSitesOnObj {border: 1px dashed #01b0e0; padding: 20px 5px 0px 15px; border-radius: 6px;}
.notEnoughMoney {display: flex; flex-direction: column;}
.notEnoughMoney p, .notEnoughMoney a {text-align: center;}
/* .ReMediaPlan >>> .notEnoughMoney p {color: #1d253b!important;} */
.ReMediaPlan >>> .bootstrap-switch{width: 70px !important; margin: 0;}
.ReMediaPlan >>> .bootstrap-switch .bootstrap-switch-label{left: 55%;}
.ReMediaPlan >>> .bootstrap-switch-container{width: 106px !important;}
.ReMediaPlan >>> .bootstrap-switch .bootstrap-switch-handle-off {text-indent: 6px; padding-right: 6px!important;}
.ReMediaPlan >>> .nav-pills .nav-item .nav-link {padding: 0px 20px;}
.ReMediaPlan >>> .tab-label > span{display: inline-flex!important;}
.ReMediaPlan >>> .siteblock {display: flex; flex-wrap: wrap;}
/* .ReMediaPlan >>> .el-table table th:nth-last-child(2)  {text-align: right;} */

/* .ReMediaPlan >>> .row-expand-hover:hover {cursor:pointer;} */
.ReMediaPlan >>> .row-expand-cover .el-table__expand-icon{visibility:hidden;}
.ReMediaPlan >>> .el-table__expand-icon {
    color: #01B0E0 !important;
	font-size: 14px;
	border: 1px solid #01B0E0;
	border-radius: 6px;
}
.ReMediaPlan >>> .el-table__expand-icon>.el-icon {
	left: 0;
    top: 0;
    margin-left: 10px;
    margin-top: 1px;
}

.ReMediaPlan >>> .el-table__expand-icon--expanded {
	transform: rotate(0deg);
}

.ReMediaPlan >>>  .el-icon-arrow-right:before {
    content: "открыть ";
    font-family: "Poppins", sans-serif;
	font-size: 0.8rem;
    font-weight: 400;
}
.ReMediaPlan >>>  .el-icon-arrow-right:after {
    content: "\e6e0";
}
.ReMediaPlan >>> .el-table__expand-icon--expanded .el-icon-arrow-right:before {
    content: "скрыть ";
    font-family: "Poppins", sans-serif;
	font-size: 0.8rem;
    font-weight: 400;
}
.ReMediaPlan >>> .el-table__expand-icon--expanded .el-icon-arrow-right:after {
    content: "\e6df";
    
}
.stat-conf > * {display: inline-block; margin-right: 10px; }
.stat-conf .stat-conf-item > span{vertical-align: super; margin-right: 5px;}


.PlanHelp .help-row .help{
	display: flex;
    flex-direction: row;
}
.PlanHelp .help-row .help img{
	max-height: 10vh;
	max-width: 30vw;
}

@media (max-width: 825px){
	.ReMediaPlan-form .btn-position {margin-top: 10px;}	
	
}
@media (max-width: 768px){
	.ReMediaPlan >>> .siteblock {flex-direction: column;}
	.ReMediaPlan >>> .el-table .cell {padding: 0px;}
	.ReMediaPlan >>> .ReActionBtns {justify-content: flex-start;}
	.ReMediaPlan >>> .nav-pills.nav-pills:not(.flex-column) .nav-item:not(:last-child) .nav-link {
		margin-bottom: 15px;
	}
	.ReMediaPlan {padding: 15px; }
	.ReMediaPlan >>> .el-table table th:nth-last-child(2) {text-align: left;}
}
@media (max-width: 525px){
	.ReMediaPlan >>> .nav-pills .nav-item .nav-link {padding: 5px 20px;}
	.ReMediaPlan >>> .ReMarketingSitesOnObj {padding: 15px 5px 0px 15px; }
}

</style>
